import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {map} from 'rxjs/operators';
// Import ContentMessageType enum
import {ContentMessageType, MessageInterface} from '../models/chat';
import {AuthorizationService} from './authorization.service';
import {environment} from '../environments/enviroment';

@Injectable({
  providedIn: 'root'
})
export class AgentResponseReceptionService {

  private domain: string = `${environment.mindxbkUrl}AgentResponseReception/Webhook/message`;

  constructor(
    private http: HttpClient,
    private authService: AuthorizationService
  ) {
  }

  // Helper function to convert enum to string
  private convertMessageTypeToString(type: ContentMessageType): string {
    switch (type) {
      case ContentMessageType.Text:
        return 'text';
      case ContentMessageType.Image:
        return 'image';
      case ContentMessageType.Video:
        return 'video';
      case ContentMessageType.Audio:
        return 'audio';
      case ContentMessageType.Document:
        return 'document';
      default:
        return 'unsupported'; // Or handle as needed
    }
  }

  // Helper method to convert string message types to enum values
  private convertMessageTypeStringToEnum(type: string): ContentMessageType {
    type = type.toLowerCase();

    switch (type) {
      case 'text':
        return ContentMessageType.Text;
      case 'image':
        return ContentMessageType.Image;
      case 'video':
        return ContentMessageType.Video;
      case 'audio':
        return ContentMessageType.Audio;
      case 'document':
        return ContentMessageType.Document;
      default:
        return ContentMessageType.Unsupported;
    }
  }

  submitMessage(message: MessageInterface): Observable<MessageInterface> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });

    const payload = {
      ...message,
      messageType:
        message.messageType !== undefined && message.messageType !== null
          ? this.convertMessageTypeToString(message.messageType)
          : 'text'
    };

    return this.http.post<MessageInterface>(this.domain, payload, {headers}).pipe(
      map((response: any) => {
        response.messageType = this.convertMessageTypeStringToEnum(response.messageType);
        return response as MessageInterface;
      })
    );
  }
}
